
const cursor = document.querySelector(".cursor")

TweenLite.set(cursor, {
    xPercent: -50,
    yPercent: -50
});

window.addEventListener("mousemove", moveCircle);
/* $('img, h1').hover(() => cursor.toggleClass('hovering')) */

function moveCircle(e) {
    TweenLite.to(cursor, 0.005, {
        x: e.clientX,
        y: e.clientY
    });
}